<template>
    <v-app>
        <component :is="layout">
            <router-view />
        </component>
        <notifications
            group="notify"
            position="bottom right"
            :speed="500"
            :duration="5000"
            :width="500"
        />
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import WebSocketService from '@/services/WebSocketService';

export default {
    name: 'App',

    computed: {
        ...mapGetters({ loggedUser: 'auth/getLoggedUser' }),

        layout() {
            const layout = this.$route.meta.layout || 'default';

            return `${layout}-layout`;
        }
    },

    watch: {
        loggedUser: {
            immediate: true,
            handler(loggedUser) {
                if (loggedUser) {
                    WebSocketService.connect(loggedUser);
                } else {
                    WebSocketService.disconnect();
                }
            }
        }
    }
};
</script>
